/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import React, { Component } from 'react';
import { debounce } from 'utils/embeds/debounce';
import AvatarEditor from 'react-avatar-editor' // https://github.com/mosch/react-avatar-editor
class Cropper extends Component {
    componentWillReceiveProps(nextProps) {
        if (this.props.logo) {
            if (nextProps.activeSelection !== 'none') {
                this.props.toggleActiveSelection()
            }
        }
    };
    onClickSave = () => {
        if (this.editor && !this.props.isGif) {
            // This returns a HTMLCanvasElement, it can be made into a data URL or a blob,
            // drawn on another canvas, or added to the DOM.
            const canvas = this.editor.getImage();
            this.props.setCanvas(canvas);
        }
    };
    setEditorRef = editor => this.editor = editor;
    previewOnZoom = debounce(() => {
        this.props.previewMethod()
    }, 300);
    render() {
        let { imageSize, image, width, height, zoom, previewMethod } = this.props;
        return (
            <div className={`cropContainer`} >
                <h4 className={`cropperTitle`} >Upload & Crop</h4>
                <AvatarEditor
                    ref={this.setEditorRef}
                    style={imageSize}
                    image={image}
                    width={width}
                    height={height}
                    border={5}
                    scale={Number(zoom)}
                    onImageChange={() => {
                        this.onClickSave();
                        this.previewOnZoom();
                    }}
                    onLoadSuccess={() => {
                        this.onClickSave();
                        previewMethod();
                    }}
                    onMouseUp={previewMethod}
                />
            </div>
        );
    }
}

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default Cropper;